export function resolveTasksMetricConfig ({
  blueprintCode,
  tasksPresentationKey,
  blueprint,
  isLoadingBlueprint
}) {
  if (!blueprintCode || !tasksPresentationKey) return {}
  if (isLoadingBlueprint || !blueprint?.definition?.data?.presentations) return {}
  const slot = blueprint.definition.data.presentations[tasksPresentationKey]
  if (!slot) return {}
  return slot.config ?? {}
}
